import { CdnClientErrorCode } from './cdn-client-error-code';
export class CdnClientError extends Error {
    /**
     * Creates a CDN Client Error instance.
     * @param code The code of the error.
     */
    constructor(code) {
        super();
        this.code = code;
        switch (code) {
            case CdnClientErrorCode.VistaProviderNotConfigured:
                this.message = 'Configuration was not provided for the Vista CDN provider.';
                break;
            case CdnClientErrorCode.UnknownError:
            default:
                this.message = 'An unknown error occurred with the CDN Client.';
        }
    }
}
//# sourceMappingURL=cdn-client-error.js.map